import { View } from 'react-native'
import { Body, DisplayValue } from '~/components/typography/Content'
import { EmailPreviewFrame } from './EmailPreviewFrame'

interface MessagePreviewPanelProps {
  preview: {
    channel: 'email' | 'sms'
    subject: string | null
    html: string | null
    text: string
  }
}

export function MessagePreviewPanel({ preview }: MessagePreviewPanelProps) {
  if (preview.channel === 'email' && preview.html) {
    return (
      <View>
        {preview.subject ? (
          <View className="border-b border-border py-4">
            <DisplayValue>{preview.subject}</DisplayValue>
          </View>
        ) : null}

        <EmailPreviewFrame html={preview.html} className="rounded-none" />
      </View>
    )
  }

  return (
    <View className="max-w-[85%] self-start rounded-2xl bg-tertiary-foreground p-4">
      <Body className="whitespace-pre-line font-medium text-primary">{preview.text}</Body>
    </View>
  )
}
